import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { PodstronaComponent } from './podstrona/podstrona.component';
import { StronaComponent } from './strona/strona.component';
import { RedirectComponent } from './redirect/redirect.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { ResetComponent } from './reset/reset.component';


const routes: Routes = [
{ path: '', component: StronaComponent },
{ path: 'polityka-prywatnosci', component: PodstronaComponent },
{ path: 'regulamin', component: PodstronaComponent },
{ path: 'confirm', component: ConfirmComponent },
{ path: 'reset', component: ResetComponent },
{ path: '**', component: RedirectComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
